@if (enabled && !!availableDownloadOptions.length) {
<a class="link_icon">
  <mat-icon [matMenuTriggerFor]="menu" class="csv-icon" tabindex="0"
    >save_alt
    <mat-menu #menu="matMenu">
      @for (downloadOption of availableDownloadOptions; track downloadOption) {
      <button
        data-testid="button-report-downloader"
        mat-menu-item
        class="text-uppercase option-button"
        (click)="downloadReport(downloadOption)"
      >
        {{ downloadOption.label | translate }}
      </button>
      }
    </mat-menu>
  </mat-icon>
</a>
}
